import React from 'react';
import { makeStyles } from '@material-ui/styles';
import * as underscore from 'underscore'
import {
    TableCell, TableRow, IconButton
} from '@material-ui/core';
import { genfunction } from 'helpers';
import CancelIcon from '@material-ui/icons/Cancel';
import { actionRemoveCoupon, actionShopCartRemoveGATicketCoupons } from 'actions';
import { actionDeleteUniqueCoupon } from 'actions';

import { useDispatch } from 'react-redux';

const useStyles = makeStyles(theme => ({

    couponAmount: {
        color: 'red'
    }
}));

const CouponItems = (props) => {

    const dispatch = useDispatch();
    const classes = useStyles();

    const DeleteCouponsHolds = (CouponID) => {
        if (props.products) {
            if (props.products.CouponItems.filter(x => x.CouponID == CouponID && x.isUniqueCoupon).length < 2) {
                return true;
            }
        }
        return false;
    }

    const removeclickhandler = (eventid, productid, couponID, couponRefHold) => {
        if (couponRefHold !== null) {
            if (DeleteCouponsHolds(couponID)) {
                actionDeleteUniqueCoupon(dispatch, couponRefHold);
            }
        }
        actionRemoveCoupon(dispatch, eventid, productid)
    }

    const getGATicketCoupon = () => {
        let filter = props.gatickets.filter(ticket => ticket.CouponCodeApplied || ticket.CouponCodeApplied != null)
        let group = underscore.groupBy(filter, (ticket) => { return ticket.CouponCodeApplied; });
        return group;
    }

    const getGATicketDiscount = (couponcode) => {
        let filter = props.gatickets.filter(ticket => ticket.CouponCodeApplied === couponcode)
        var totalDiscount = underscore.reduce(filter, ((memoizer, ticket) => memoizer + (ticket.OriginalTotalAmount - ticket.TotalAmount)), 0);
        return totalDiscount;
    }

    const getGATicketAmount = () => {
        var totalAmount = underscore.reduce(props.gatickets, ((memoizer, ticket) => memoizer + ticket.OriginalTotalAmount), 0);
        return totalAmount;
    }

    const getDonationProductAmount = () => {
        let total = 0;
        props.donationProducts.forEach(product => {
            total += product.Amount;
        });
        return total;
    }

    const removeGATicketCouponClickHandler = (couponCode) => {
        actionShopCartRemoveGATicketCoupons(dispatch, couponCode);
    }

    return (
        <>
            {/* TourEventCoupon */}
            {props.products ?
                <TableRow key={props.products.TourEventID}>
                    <TableCell>{props.products.EventName}</TableCell>
                    <TableCell align="right">{genfunction.ccyFormat(
                        genfunction.IsNotFullPay(props.products.PaymentOption) ? props.products.TotalSelectedAmount : props.products.TotalAmount)}</TableCell>
                </TableRow> : null}
            {props.products && props.products.CouponItems.length > 0 ?
                props.products.CouponItems.map(e =>
                    <TableRow >
                        <TableCell className={classes.tablecell} align="left">
                            <IconButton
                                edge="end"
                                size="small"
                                onClick={() => removeclickhandler(e.TourEventID, e.TourProductID, e.CouponID, e.CouponHoldRef)}>
                                <CancelIcon color={"error"} />
                            </IconButton>{'      ' + e.ApplyDiscountTourProductName + '      (' + e.UniqueCouponCode + ')'}
                        </TableCell>
                        <TableCell align="right" className={classes.couponAmount}>-{genfunction.ccyFormat(
                            genfunction.IsNotFullPay(e.PaymentOption) ? e.TotalSelectedAmount : e.TotalAmount)}</TableCell>
                    </TableRow>
                ) : null
            }

            {props.donationProducts && props.donationProducts.length > 0 ?
                <TableRow key={"DonationProducts"}>
                    <TableCell>{"Donations"}</TableCell>
                    <TableCell align="right">{genfunction.ccyFormat(getDonationProductAmount())}</TableCell>
                </TableRow> : null}

            {/* GATicketCoupon */}
            {props.gatickets && props.gatickets.length > 0 ?
                <TableRow key={"GATicket"}>
                    <TableCell>{"Tickets"}</TableCell>
                    <TableCell align="right">{genfunction.ccyFormat(getGATicketAmount())}</TableCell>
                </TableRow> : null}
            {props.gatickets && props.gatickets.length > 0 ?
                underscore.map(getGATicketCoupon(), (items, groupby) => {
                    return (
                        <TableRow key={groupby}>
                            <TableCell className={classes.tablecell} align="left">
                                <IconButton
                                    edge="end"
                                    size="small"
                                    onClick={() => removeGATicketCouponClickHandler(groupby)}
                                >
                                    <CancelIcon color={"error"} />
                                </IconButton>{'Ticket Coupon (' + groupby + ")"}
                            </TableCell>
                            <TableCell align="right">-{genfunction.ccyFormat(getGATicketDiscount(groupby))}</TableCell>
                        </TableRow>
                    )
                }) : null}


            {props.giftcards ?
                <TableRow key={props.giftcards.ProductID}>
                    <TableCell>{props.giftcards.ProductName}</TableCell>
                    <TableCell align="right">{genfunction.ccyFormat(props.giftcards.CartTotalAmount)}</TableCell>
                </TableRow> : null}


        </>
    );
}

export default CouponItems;